<div class="save-changes-modal-all">
  <div class="save-changes-modal-header">
    <h5 class="modal-title">
      {{ "financial-information.save_without_change_modal.title" | translate }}
    </h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="discardChanges()"
    ></button>
  </div>

  <div class="save-changes-modal-body">
    <div>
      <p class="modal-text">
        {{
          "financial-information.save_without_change_modal.text1" | translate
        }}
      </p>
      <p class="modal-text">
        {{
          "financial-information.save_without_change_modal.text2" | translate
        }}
      </p>
    </div>
  </div>

  <div class="save-changes-modal-footer">
    <button type="button" class="keep-editing-btn" (click)="keepEditing()">
      {{
        "financial-information.save_without_change_modal.keep_editing"
          | translate
      }}
    </button>

    <button type="button" class="btn-cancel" (click)="discardChanges()">
      {{ "financial-information.save_without_change_modal.cancel" | translate }}
    </button>
  </div>
</div>
